export const SEARCH_INPUT_USER_BUYER = 'SEARCH_INPUT_USER_BUYER'
export const SEARCH_OPTION_USER_BUYER = 'SEARCH_OPTION_USER_BUYER'
